import $ from 'jquery'
import invariant from 'ts-invariant'

interface Coordinates {
  left: number
  top: number
}

export function getElementOffset(element: HTMLElement): Coordinates {
  const offset = $(element).offset()
  invariant(offset)

  return offset
}

export function getElementOuterWidth(element: HTMLElement): number {
  const width = $(element).outerWidth()
  invariant(typeof width === 'number')

  return width
}

export function getElementOuterHeight(element: HTMLElement): number {
  const height = $(element).outerHeight()
  invariant(typeof height === 'number')

  return height
}

export function getDocumentOuterHeight() {
  return $(document).outerHeight()
}

export function setElementPosition(
  element: HTMLElement,
  top: number | null,
  left: number | null
) {
  const px = (n: number | null) => (n === null ? '' : `${n}px`)

  $(element).css({
    top: px(top),
    left: px(left),
  })
}

export function fadeOutAndRemove(el: HTMLElement, duration = 100) {
  $(el).fadeOut(duration, () => el.remove())
}

export function fadeIn(el: HTMLElement, duration = 100) {
  $(el).fadeIn(duration)
}
